<h2 mat-dialog-title class="mcp-modal__title">
  <app-icon name="shield" [size]="20" aria-hidden="true" />
  MCP access
</h2>

<mat-dialog-content>
  <p class="mcp-modal__lead">
    Choose what <strong>{{ data.user.full_name || data.user.email }}</strong> can
    reach when they connect Claude to the CapX MCP server. Access is read-only and
    granted explicitly per person.
  </p>

  <mat-radio-group
    class="mcp-modal__options"
    [value]="selected()"
    (change)="select($event.value)"
    aria-label="MCP access tier"
  >
    @for (opt of options; track opt.label) {
      <mat-radio-button
        class="mcp-modal__option"
        [class.mcp-modal__option--active]="selected() === opt.value"
        [value]="opt.value"
      >
        <span class="mcp-modal__option-body">
          <span class="mcp-modal__option-label">{{ opt.label }}</span>
          <span class="mcp-modal__option-desc">{{ opt.description }}</span>
        </span>
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (selected() === 'HIGH') {
    <p class="mcp-modal__warn">
      <app-icon name="alert-triangle" [size]="14" aria-hidden="true" />
      Full access exports unredacted personal data to an external AI client.
      Grant only when there is a clear, POPIA-justified need.
    </p>
  }

  @if (error()) {
    <p class="mcp-modal__error">
      <app-icon name="x-circle" [size]="14" aria-hidden="true" />
      Couldn't save the change. Please try again.
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving()">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="save()"
    [disabled]="!dirty || saving()"
  >
    {{ saving() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
